let Profile = require('./profile');
const ProfileData = require('./profileData');

function BillingUser(userData) {
    let user = userData || {};
    this.id = user.id;
    this.acceptedCookies = user.acceptedCookies;
    this.activationDate = new Date(user.activationDate);
    this.creationDate = new Date(user.creationDate);
    this.email = user.email;
    this.lastChangedDate = new Date(user.lastChangeDate);
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.profiles = user.profiles !== undefined &&  user.profiles !== null ? user.profiles.map(p => new Profile(p)): [];
    this.goCardlessRedirectIds = user.goCardlessRedirectIds !== undefined && user.goCardlessRedirectIds !== null ? Object.keys(user.goCardlessRedirectIds).map(g =>  new ProfileData(g, user.goCardlessRedirectIds[g])) : [];
}

module.exports = BillingUser;